import { useTimeService } from '@mews-commander/ui';
import { useDateTimeCompoundField } from '@mews/framework';
import { CompoundField, CompoundFieldProps } from '@optimus-web/core';
import { DateField, DateFieldProps } from '../DateField';
import { TimeField, TimeFieldProps } from '../TimeField';

interface DateTimeFieldProps extends Omit<CompoundFieldProps, 'children'> {
    dateProps?: Partial<Omit<DateFieldProps, 'name' | 'size' | 'label' | 'mode'>>;
    timeProps?: Partial<Omit<TimeFieldProps, 'name' | 'size' | 'label'>>;
    onChange?: (value?: string | null) => void;
}

export const DateTimeField = ({ dateProps, timeProps, size, onChange, ...props }: DateTimeFieldProps) => {
    const timeService = useTimeService();
    const { dateFieldName, timeFieldName, defaultValues, handleParsedDateChange, handleDateChange, handleTimeChange } =
        useDateTimeCompoundField({
            name: props.name,
            onChange,
            dateProps,
            timeProps,
            timeService,
        });

    return (
        <CompoundField {...props}>
            <DateField
                name={dateFieldName}
                mode="iso"
                {...dateProps}
                size={size}
                onChange={handleDateChange}
                onDateChange={handleParsedDateChange}
                defaultValue={defaultValues.date}
            />
            <TimeField
                name={timeFieldName}
                mode="iso"
                {...timeProps}
                size={size}
                onChange={handleTimeChange}
                defaultValue={defaultValues.time}
            />
        </CompoundField>
    );
};
